import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';
import { FileUploadModule } from 'ng2-file-upload';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { ImageCropperModule } from "ng2-img-cropper";
import { BsDropdownModule, PopoverModule, TypeaheadModule } from 'ngx-bootstrap';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgProgressModule } from 'ngx-progressbar';
import { CKEditorModule } from 'ng2-ckeditor';
import { CollapsibleModule } from 'angular2-collapsible';
import { TypeaheadDropdownComponent } from "../common/typeahead-dropdown/typeahead-dropdown.component";
import { FormInviteModalComponent } from "../form/form-invite-modal/form-invite-modal.component";
import { DateValidatorDirective } from "../common/validators/date-validator.directive";
import { ValidateStateDirective} from '../common/validators/state-validators.directive';
import { AllowedCharactersValidatorDirective } from "../common/validators/allowed-characters-validator.directive";
import { NumericValidatorDirective } from "../common/validators/numeric-validator.directive";
import { LengthValidatorDirective } from "../common/validators/length-validator.directive";
import { EmailValidatorDirective } from "../common/validators/email-validator.directive";
import { EqualValidatorDirective } from "../common/validators/equal-validtor.directive";
import { ArchwizardModule } from "ng2-archwizard/dist";
import { StateIdPipe } from "../common/pipes/state-id.pipe";
import { ChartsModule } from "ng2-charts";
import { EmployeeListComponent } from "../employee/employee-list/employee-list.component";
import { NgxPaginationModule } from "ngx-pagination";
import { EmployeeListTableComponent } from "../employee/employee-list-table/employee-list-table.component";
import { LoadingComponentComponent } from "../common/loading-component/loading-component.component";
import { ValidateDistrictDirective} from '../common/validators/district-validators.directive'
import { MaintenanceModeComponent } from "../common/maintenance-mode/maintenance-mode.component";


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HttpModule,
        RouterModule,
        FileUploadModule,
        MultiselectDropdownModule,
        BsDropdownModule.forRoot(),
        ModalModule.forRoot(),
        NgProgressModule,
        PopoverModule.forRoot(),
        ImageCropperModule,
        TypeaheadModule.forRoot(),
        CKEditorModule,
        CollapsibleModule,
        ArchwizardModule,
        ChartsModule,
        NgxPaginationModule,

    ],
    declarations: [
        TypeaheadDropdownComponent,
        FormInviteModalComponent,
        DateValidatorDirective,
        AllowedCharactersValidatorDirective,
        NumericValidatorDirective,
        ValidateStateDirective,
        ValidateDistrictDirective,
        LengthValidatorDirective,
        EmailValidatorDirective,
        EqualValidatorDirective,
        StateIdPipe,
        EmployeeListTableComponent,
        EmployeeListComponent,
        LoadingComponentComponent,
        MaintenanceModeComponent,

    ],
    exports: [
        BsDropdownModule,
        ModalModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HttpModule,
        RouterModule,
        FileUploadModule,
        MultiselectDropdownModule,
        PopoverModule,
        ImageCropperModule,
        TypeaheadModule,
        CKEditorModule,
        CollapsibleModule,
        TypeaheadDropdownComponent,
        ChartsModule,
        EmployeeListTableComponent,
        EmployeeListComponent,
        NgxPaginationModule,
        FormInviteModalComponent,
        DateValidatorDirective,
        AllowedCharactersValidatorDirective,
        NumericValidatorDirective,
        LengthValidatorDirective,
        EmailValidatorDirective,
        EqualValidatorDirective,
        ArchwizardModule,
        StateIdPipe,
        LoadingComponentComponent,
    ]
})
export class SharedModule {

}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/core/shared.module.ts